module.exports = __webpack_public_path__ + "static/media/San.98ab6b4b.png";